import ConnectedToggle from "components/screener/shared/ConnectedToggle";
import { FormattedMessage } from "react-intl";

export default function IsAmericanDepositaryReceipt() {
  return (
    <div className="space-y-2">
      <h3 className="font-aeonik text-base font-bold tracking-wide text-zinc-500">
        <FormattedMessage defaultMessage="ADRs" id="0A84Ku" />
      </h3>

      <div className="flex items-center justify-between">
        <span className="flex font-aeonik text-sm font-normal italic tracking-wider text-slate-400">
          <FormattedMessage defaultMessage="Filtre por Stocks que são ADRs" id="zd6nGI" />
        </span>

        <ConnectedToggle label="BDRs" attribute="isAmericanDepositaryReceipt" value={true} />
      </div>
    </div>
  );
}
